export default "__VITE_ASSET__CHl8v3ZS__"